module.exports = __webpack_public_path__ + "img/games.df6fa06e.svg";